<template>
  <div class="short-cut-container">
    <div v-for="item in dataList" :key="item.id" class="short-cut-item" @click="onClick(item)">
      <img :src="item.image_url" />
      <div class="title">
        {{item.title}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ShortCutComponent",
    props: {
      dataList: {
      }
    },
    data() {
      return {}
    },
    methods: {
      onClick(item) {
        if (item.to) {
          this.$router.push(item.to)
        } else if (item.href) {
          window.location.replace(item.href)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .short-cut-container {
    background: white;
    display: flex;
    flex-wrap: wrap;

    .short-cut-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 20%;

      img {
        width: 35px;
        height: 35px;
      }

      .title {
        margin-top: 10px;
        font-size: 13px;
        color: rgba(88, 88, 88, 0.8);
      }
    }
  }

</style>
